import store from '../../store'
import {mapGetters} from 'vuex'

export default {
  data: function () {
    return {
      activityID: 0,
    }
  },
  props: ['medicalAlleyStartsObjects'],
  computed: {
    objects () {
      return this.medicalAlleyStartsObjects.objects
    },
    tags () {
      return this.medicalAlleyStartsObjects.tags
    },
    ...mapGetters(['medicalAlleyStartsQuery', 'queriedActivities', 'queriedTags', 'isQueryDirty'])
  },
  methods: {
    addQueryParam (key, value) {
      store.commit('addToMedicalAlleyStartsQuery', [key, value])
    },
    resetQuery () {
      store.commit('resetMedicalAlleyStartsQuery')
      this.$emit('queryChanged')
    },
    addTagParam (tagID) {
      if (store.getters.queriedTags.indexOf(tagID) > -1) {
        return
      }
      store.commit('addTagParam', tagID)
    },
    removeTagParam (tagID) {
      //  If tag is not in store, bail.
      let indexOfTag = store.getters.queriedTags.indexOf(tagID)
      if (indexOfTag === -1) {
        return
      }
      store.commit('removeTagParam', indexOfTag)
    },
    isTagInQuery (tagID) {
      return store.getters.queriedTags.indexOf(tagID) > -1
    },
    addActivity (activitySearchObject) {
      activitySearchObject.id = this.activityID
      this.activityID++
      store.commit('addActivitySearch', activitySearchObject)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/medicalAlleyStarts/MedicalAlleyStartsMixin.js